import axios from 'axios';
import { RouteScanSummary } from '../models/RouteScanSummary';
import { RouteParcel } from '../models/RouteParcel';
import { RerouteParcelsResult } from '../models/RerouteParcelsResult';
import { RerouteParcelsRequest } from '../models/RerouteParcelsRequest';

const baseUrl = process.env.REACT_APP_API_URL;

axios.defaults.withCredentials = process.env.REACT_APP_WITH_CREDENTIALS === "true";

export const GetRouteSummaries = async(): Promise<RouteScanSummary[]> => {
    var date = new Date();
    var url = baseUrl + "/routes/summaries/" + date.toDateString();

    var response = axios.get<RouteScanSummary[]>(url);

    return response.then(r => r.data)
        .catch(error => { return Promise.reject(error) });
}

export const GetRouteParcels = async(routeNumber: string): Promise<RouteParcel[]> => {
    var date = new Date();
    var url = baseUrl + "/routes/route/" + routeNumber;

    var response = axios.get<RouteParcel[]>(url, { params: { activityDate: date.toDateString() }});

    return response.then(r => r.data)
        .catch(error => { return Promise.reject(error) });
}

export const GetRoutesInSameTerritory = async (routeNumber: string): Promise<string[]> =>{
    let url = baseUrl + "/routes/routesinsameterritory/" + routeNumber;

    var response = axios.get<string[]>(url);

    return response.then(r => r.data)
        .catch(error => { return Promise.reject(error) });
}

export const RerouteParcels = async(newRouteNumber: string, parcels: RouteParcel[]): Promise<RerouteParcelsResult> => {
    var request: RerouteParcelsRequest =
    {
        newRouteNumber: newRouteNumber,
        parcels: parcels
    };

    var url = baseUrl + "/Delivery/RerouteParcels";

    var response = axios.post<RerouteParcelsResult>(url, request );

    return response.then(r => r.data)
        .catch(error => { return Promise.reject(error) });
}

